import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { adminColumns } from "../../datatablesource";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import {
  collection,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../../../../firebase";
import userController from "../../../../controllers/usercontroller";

const AdminDatatable = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {

    // LISTEN (REALTIME)
    const unsub = onSnapshot(
      collection(db, "admin"),
      (snapShot) => {
        let list = [];
        snapShot.docs.forEach((doc) => {
          list.push({ id: doc.id, ...doc.data() });
        });
        setData(list);
      },
      (error) => {
        console.log(error);
      }
    );

    return () => {
      unsub();
    };
  }, []);

  const handleView = async (id) => {
    navigate(`${id}`);
  }

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction" >
            <div className="viewButton" onClick={() => handleView(params.row.id)}>Ouvrir</div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="datatable">
      <div className="datatableTitle">
        <p className="ctitle">{t('administrators_list')}</p>
        <Link to="/admin/administrators/new" className="link btn-primary">
          {t('new_administrator')}
        </Link>
      </div>
      <DataGrid
        className="datagrid"
        rows={data}
        columns={adminColumns}
        pageSize={9}
        rowsPerPageOptions={[9]}
        
      />
    </div>
  );
};

export default AdminDatatable;
